import * as React from 'react';
import Draggable from 'react-draggable';
import debounce = require('lodash/debounce');
import {VideoContainer} from '../../video-pane/video-pane';
import {ConnectionlessVideo} from '../../video-pane/connectionless-video';
import {Popover} from '../../popover/popover';
import './styles.sass';

export interface ISessionVideoProps {
    ackVideo?: () => void;
    showVideoHint?: boolean;
    connectionless?: boolean;
    runCommand: (command: string, data: any) => void;
    getContentBoundingClientRect: () => ClientRect;
    isSendingScreen?: boolean;
    room?: any;
    sendScreen?: () => void;
}

interface ISessionVideoState {
  videoPosition?: {
    x: number;
    y: number;
  };
  videoBounds?: {
    left: number;
    top: number;
    right: number;
    bottom: number;
  };
}

// half header height
const VIDEO_DRAG_PADDING: number = 16;

export class SessionVideo extends React.Component<ISessionVideoProps, ISessionVideoState> {
  public draggableRef = React.createRef<HTMLDivElement>();

  public state: ISessionVideoState = {
    videoPosition: {
      x: 9999,
      y: 0,
    },
    videoBounds: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
    },
  };

  public componentDidMount(): void {
    window.addEventListener('resize', this.onWindowResize);

    // trigger resize to show video container on right side
    this.onWindowResize();
  }

  public componentWillUnmount(): void {
    window.removeEventListener('resize', this.onWindowResize);
  }

  public render(): React.ReactElement<{}> {
    const {
      props: {isSendingScreen, room, sendScreen, showVideoHint},
      state: {videoBounds, videoPosition},
    } = this;

    return (
      <Draggable position={videoPosition} bounds={videoBounds} onDrag={this.onVideoDrag} onStart={this.onStartDrag}>
        <div className='session-video' ref={this.draggableRef}>
          {
            this.props.connectionless
              ? <ConnectionlessVideo draggable />
              :
                <VideoContainer
                  runCommand={this.props.runCommand}
                  isSendingScreen={isSendingScreen}
                  room={room}
                  sendScreen={sendScreen}
                  draggable
                />
          }
          <Popover visible={showVideoHint} isHint={true}>
            <p className={'popover-component-text'}>
              Drag me
            </p>
          </Popover>
        </div>
      </Draggable>
    );
  }

  private onStartDrag = () => {
    if (this.props.showVideoHint) {
      this.props.ackVideo();
    }
  };

  private onVideoDrag = (event: MouseEvent, data) => {
    // prevent default to stop selecting text while dragging
    event.preventDefault();

    this.setState({
      videoPosition: {
        x: data.x,
        y: data.y,
      },
    });
  };

  /* tslint:disable:member-ordering */
  private onWindowResize = debounce(() => {
    const {width: videoWidth, height: videoHeight} = this.getVideoBoundingClientRect();
    const contentHeight = this.props.getContentBoundingClientRect().height;
    const contentWidth = window.innerWidth;

    this.setState({
      videoPosition: {
        x: contentWidth - videoWidth - VIDEO_DRAG_PADDING,
        y: VIDEO_DRAG_PADDING,
      },
      videoBounds: {
        left: VIDEO_DRAG_PADDING,
        right: contentWidth - videoWidth - VIDEO_DRAG_PADDING,
        top: 0,
        bottom: contentHeight - videoHeight - VIDEO_DRAG_PADDING,
      },
    });
  });
  /* tslint:enable:member-ordering */

  private getVideoBoundingClientRect(): ClientRect {
    return this.draggableRef.current.getBoundingClientRect();
  }
}
